export default {
	path: '/',
	icon: '',
	meta: {
		title: '网课管理'
	},
	children: [
		{
			path: '/',
			icon: '',
			ignore: true, //忽略权限校验
			component: '',
			meta: {
				title: '网课开通'
			},
			children: [
				{
					path: '/OC/classList',
					name: 'OpenClassListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/onlineClass/openClass/classList'),
					meta: {
						title: '网课列表'
					}
				},
				{
					path: '/OC/openApply',
					name: 'OpenApplyIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/onlineClass/openClass/openApply'),
					meta: {
						title: '开通申请'
					}
				},
				{
					path: '/OC/openApplyWait',
					name: 'OpenApplyWaitIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/onlineClass/openClass/openApplyWait'),
					meta: {
						title: '待开通'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			ignore: true, //忽略权限校验
			component: '',
			meta: {
				title: '网课退费申请'
			},
			children: [
				{
					path: '/OC/refundApply',
					name: 'RefundApplyIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/onlineClass/refundClass/refundApply'),
					meta: {
						title: '退费申请'
					}
				},
				{
					path: '/OC/refundApplyXz',
					name: 'RefundApplyXZIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/onlineClass/refundClass/refundApplyXz'),
					meta: {
						title: '退费审核-行政'
					}
				},
				{
					path: '/OC/refundApplyWx',
					name: 'RefundApplyWXIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/onlineClass/refundClass/refundApplyWx'),
					meta: {
						title: '退费审核-网校'
					}
				},
				{
					path: '/OC/refundApplyCw',
					name: 'RefundApplyCWIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/onlineClass/refundClass/refundApplyCw'),
					meta: {
						title: '退费审核-财务'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title:'网课图书邮寄管理'
			},
			children: [
				{
					path: '/OC/AppMail',
					name: 'appMailIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/onlineClass/onlineCourseBookManagement/bookDetails/index.vue'),
					meta: {
						title: '网课图书邮寄明细'
					}
				},
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '图书管理'
			},
			children: [
				{
					path: '/order/bookList',
					name: 'BookListIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/bookList'),
					meta: {
						title: '图书列表'
					}
				},
				{
					path: '/order/bookOutbound',
					name: 'BookOutboundIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/bookOutbound'),
					meta: {
						title: '图书出库'
					}
				},
				{
					path: '/order/bookStorage',
					name: 'BookStorageIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/bookStorage'),
					meta: {
						title: '图书入库'
					}
				},
				{
					path: '/order/bookDelivery',
					name: 'BookDeliveryIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/bookDelivery'),
					meta: {
						title: '图书发货'
					}
				},
				{
					path: '/order/outboundAudit',
					name: 'OutboundAuditIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/outboundAudit'),
					meta: {
						title: '图书出库审核'
					}
				},
				{
					path: '/order/bookRefundReview',
					name: 'BookRefundReviewIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/bookRefundReview'),
					meta: {
						title: '图书退费审核'
					}
				}
			]
		}
	]
}
